import { render, staticRenderFns } from "./LoyaltyPrograms.vue?vue&type=template&id=5cb22762"
import script from "./LoyaltyPrograms.vue?vue&type=script&lang=ts"
export * from "./LoyaltyPrograms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports